import Component from '../Component';
import Element from '../../Prototype/UI/Element';
import * as PIXI from 'pixi.js';
import '@softgames/pixi-ui';
import UIVerticalGroupComponent from './VerticalGroup';
import Point from '../../Utility/Point';

export default class ElementComponent extends Component<
    PIXI.ui.Element,
    Element
> {
    public type: string = undefined;
    public name: string = undefined;
    public components: any[] = [];

    get anchorX1(): number {
        return this.container.anchorTopLeft.x;
    }

    get anchorX2(): number {
        return this.container.anchorBottomRight.x;
    }

    get anchorY1(): number {
        return this.container.anchorTopLeft.y;
    }

    get anchorY2(): number {
        return this.container.anchorBottomRight.y;
    }

    set anchorX1(value: number) {
        this.container.anchorTopLeft.x = value;
    }

    set anchorX2(value: number) {
        this.container.anchorBottomRight.x = value;
    }

    set anchorY1(value: number) {
        this.container.anchorTopLeft.y = value;
    }

    set anchorY2(value: number) {
        this.container.anchorBottomRight.y = value;
    }

    set anchors(value: [number, number, number, number]) {
        this.anchorX1 = value[0];
        this.anchorY1 = value[1];
        this.anchorX2 = value[2];
        this.anchorY2 = value[3];
    }
    get anchors(): [number, number, number, number] {
        return [this.anchorX1, this.anchorY1, this.anchorX2, this.anchorY2];
    }

    get offsets(): [number, number, number, number] {
        return [this.offsetX1, this.offsetY1, this.offsetX2, this.offsetY2];
    }

    set offsets(value: [number, number, number, number]) {
        this.offsetX1 = value[0];
        this.offsetY1 = value[1];
        this.offsetX2 = value[2];
        this.offsetY2 = value[3];
    }

    get offsetX1(): number {
        return this.container.offsetTopLeft.x;
    }

    get offsetX2(): number {
        return this.container.offsetBottomRight.x;
    }

    get offsetY1(): number {
        return this.container.offsetTopLeft.y;
    }

    get offsetY2(): number {
        return this.container.offsetBottomRight.y;
    }

    set offsetX1(value: number) {
        this.container.offsetTopLeft.x = value;
    }

    set offsetX2(value: number) {
        this.container.offsetBottomRight.x = value;
    }

    set offsetY1(value: number) {
        this.container.offsetTopLeft.y = value;
    }

    set offsetY2(value: number) {
        this.container.offsetBottomRight.y = value;
    }

    get anchorTopLeft(): Point {
        return this.container.anchorTopLeft as any;
    }

    set anchorTopLeft(value: Point) {
        this.container.anchorTopLeft.set(value.x, value.y);
    }

    get anchorBottomRight(): Point {
        return this.container.anchorBottomRight as any;
    }

    set anchorBottomRight(value: Point) {
        this.container.anchorBottomRight.set(value.x, value.y);
    }

    get rotation(): number {
        return this.container.rotation;
    }

    set rotation(value: number) {
        this.container.rotation = value;
    }

    get offsetTopLeft(): Point {
        return this.container.offsetTopLeft as any;
    }

    set offsetTopLeft(value: Point) {
        // prettier-ignore
        if (!this.gameObject.parent || !this.gameObject.parent.hasComponent(UIVerticalGroupComponent)) {
            this.container.offsetTopLeft.set(value.x, value.y);
        }
    }

    get offsetBottomRight(): Point {
        return this.container.offsetBottomRight as any;
    }

    set offsetBottomRight(value: Point) {
        // prettier-ignore
        if (!this.gameObject.parent || !this.gameObject.parent.hasComponent(UIVerticalGroupComponent)) {
            this.container.offsetBottomRight.set(value.x, value.y);
        }
    }

    get pivot(): Point {
        return this.container.elementPivot as any;
    }

    set pivot(value: Point) {
        this.container.elementPivot.set(value.x, value.y);
    }

    get scale(): Point {
        return this.container.scale as any;
    }

    set scale(value: Point) {
        this.container.scale.set(value.x, value.y);
    }

    get heightMax(): number {
        return this.container.heightMax;
    }

    set heightMax(value: number) {
        this.container.heightMax = value;
    }

    get heightMin(): number {
        return this.container.heightMin;
    }

    set heightMin(value: number) {
        this.container.heightMin = value;
    }

    get widthMax(): number {
        return this.container.widthMax;
    }

    set widthMax(value: number) {
        this.container.widthMax = value;
    }

    get widthMin(): number {
        return this.container.widthMin;
    }

    set widthMin(value: number) {
        this.container.widthMin = value;
    }

    set position(value: Point) {
        this.anchors = [0, 0, 0, 0];
        this.offsets = [-value.x, -value.y, -value.x, -value.y];
    }
    get position(): Point {
        return new Point(
            this.anchorX1 * this.gameObject.parent.container.width +
                this.offsetX1,
            this.anchorY1 * this.gameObject.parent.container.height +
                this.offsetY1
        );
    }
    set globalPosition(value: Point) {
        if (this.gameObject.parent) {
            this.position = new Point(
                value.x - this.gameObject.parent.container.worldTransform.tx,
                value.y - this.gameObject.parent.container.worldTransform.ty
            );
        } else {
            this.position = new Point(value.x, value.y);
        }
    }
    get globalPosition(): Point {
        return new Point(
            this.gameObject.container.worldTransform.tx,
            this.gameObject.container.worldTransform.ty
        );
    }
}
